<template>
  <div class="Flex Flex--d-c PageWrapper" id="PageWrapper" ref="PageWrapper">
    <div class="FlexItem childView">
      <div class="FlexItem">
        <div class="containerCls">
          <div class="infoArea"
            :style="{ height: chatingData.length > 0 ? '4.8rem' : '', bottom: chatingData.length > 0 ? '1.7rem' : '4rem' }">
            <div class="tipsArea" id="section">
              <div class="item-guide">您可以尝试问我这些问题：</div>
              <div class="tips-item" v-for="(item, index) in tipChatList" :key="index" @click="onTipClick(item)">
                · {{ item.question }}</div>
            </div>
            <div :class="['questionArea', isMb ? 'phoneArea' : 'pcArea']" id="question-section">
              <div v-for="(item, index) in chatingData" :key="index"
                :class="[item.type === 1 ? 'call-message-user-item' : '', item.type === 2 || item.type === 3 ? 'call-message-agent-item' : '',]">
                <div class="is-user" v-if="item.type === 1">
                  <div :class="['thinking-icon']" v-if="item.isLoading"></div>
                  <template v-else>
                    <div class="_content">{{ item.text }}</div>
                  </template>
                </div>

                <div class="is-agent" v-if="item.type === 2">
                  <div class="_content" v-if="chatLoading && !item.text">
                    <div class="thinking-area">
                      <div class="thinking-icon"></div>
                      <div class="thinking-text">{{ "小蜀正在思考中..." }}</div>
                    </div>

                  </div>

                  <div class="_content" v-if="item.text">
                    <vue-typed-js v-if="item.isSample" :strings="[item.text]" :typeSpeed="50" :autoInsertCss="false"
                      :showCursor="false" @onComplete="onStopType" @preStringTyped="onStringTyped">
                      <span class="typeing"></span>
                    </vue-typed-js>
                    <span v-else>
                      {{ (pageInfo[index] && item.isOver) ? item.list[pageInfo[index] - 1]?.text : item.text }}
                    </span>
                    <div class="tag">由智媒云大模型生成</div>
                  </div>
                </div>
                <div class="is-agent" v-if="item.type === 3">
                  <div class="_content">
                    <div class="thinking-area">
                      <div class="thinking-text"> {{ item.text === '服务器内部错误' ? '抱歉，这个问题我无法回答，咱们换个话题聊聊吧！' : item.text ||
              '暂无响应'
                        }}</div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>


          <!-- <div class="tipsArea" id="section">
            <div class="item-guide">您可以尝试问我这些问题：</div>
            <div class="tips-item" v-for="(item, index) in tipChatList" :key="index" @click="onTipClick(item)">
              · {{ item.question }}</div>
          </div> -->
          <div class="logoArea"></div>
          <div class="verseArea" @click="refreshPage"></div>

          <transition name="fadeInput">
            <div :class="[
              'questionBox',
            ]" id="questionBox" v-if="isInputShow">
              <!-- 输入框 -->
              <div :class="['ComposerPC', 'isCompact']" v-if="!isVoiceInput">
                <!--修改input的限制字数-->
                <input id="inputValue" ref="searchInput" type="text" placeholder="欢迎体验智媒云大模型生态-DeepSeek版"
                  v-model.trim="inputValue" class="inputCls" maxlength="2000" @blur="onBlur" :disabled="chatLoading"
                  v-on:input="onRate" />

                <div class="button" v-if="!inputBtnInit" :style="{ backgroundColor: robotConfig.primaryColor }">
                  <span class="send" @click="onAsk"></span>
                </div>
                <!-- 切换输入的方式 -->
                <!-- <div class="button" v-else>
                  <img src="../assets/img/home/voiceBtn.png" alt="切换页面输入方式" @click="onChangeInputType(true)"
                    class="button-icon" />
                </div> -->
              </div>
              <!-- 语音 -->
              <div v-else>
                <VoiceInputView @onChangeInputType="onChangeInputType" :person="'小蜀'">
                </VoiceInputView>
              </div>
            </div>

            <div class="voiceInput-wapper">
              <VoiceInputView @onChangeInputType="onChangeInputType" @click="onVoiceInputClick" :person="'小蜀'">
                <audio id="AutoplayRef" autoplay src="" @error="onAudioError"></audio>
              </VoiceInputView>
            </div>
          </transition>
          <div class="tips-info">中国互联网发展基金会中国正能量网络传播专项基金支持项目</div>
          <div class="registration-number">大模型备案编号：Sichuan-ZhiMeiYunDaMoXing-20240830S0003</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import COVERAPP from "@/utils/COVERAPP";
import { parseData, popConfirm } from "@/utils/utils";
import AudioBar from "./Use/audio-bar";
import VoiceInputView from "./Use/VoiceInputView";

export default {
  name: "PageWrapper",
  components: {
    AudioBar,
    VoiceInputView,
    // VueTypedJs,
  },
  props: {},
  data() {
    return {
      inputValue: "",
      isToast: false,
      toastCurrList: [],
      inputBtnInit: true, //输入按钮的初始状态
      isFold: false,
      chatingData: [],
      tipChatList: [
        {
          question: "为什么上网常常需要实名认证？",
        },
        {
          question: "我的个人信息被网站收集了，法律如何保护？",
        },
        // {
        //   question: "发现网络诈骗或者危害网络安全的行为，我该怎么办？",
        // },
      ],
      npcTip: "我想看看四川的人大代表都提了什么?",
      pageInfo: {}, // 所有分页
      foldInfo: {}, // 所有折叠信息
      typedIntervel: null,
      audioPlayerIndex: 0,
    };
  },
  created() {
    this.setUserIdRandom()

    // 判断是否移动端 
    // if (browser.versions.mobile || browser.versions.android || browser.versions.ios) {
    //   console.log("移动端");
    //   console.log('browser.versions.ios: ', browser.versions.ios)
    //   console.log('browser.versions.mobile: ', browser.versions.mobile)
    // }

  },
  mounted() {
    this.$nextTick(() => {

      // 监听输入框软键盘回车键，点击回车键，软键盘收起
      this.$refs.searchInput?.addEventListener("keyup", (e) => {
        if (e.keyCode == 13) {
          this.$refs.searchInput.blur();
          this.onAsk();
        }
      });
    });

    // setTimeout(() => {
    try {
      this.initAudioInput(true)
    } catch (e) {
      console.log('报错:', e)
    }
    // }, 1000)
  },
  watch: {
    chatData: {
      handler(newval, oldval) {
        this.chatingData = newval
        this.goToBottom()
      },
      deep: true
    },
    audioList: {
      handler(newval, oldval) {
        if (newval.length == 1) {
          if (!this.audioPlayerIndex) {
            this.playAudio(newval[this.audioPlayerIndex])
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState([
      "toastList",
      "noticeList",
      "globalDuration",
      "device",
      "isOpenChat",
      "readNewsId",
      "isInputShow",
      "questionTips",
      "guideTips",
      "isTourShow",
      "selectList",
      "tagsList",
      "audioSelectData",
      "isAudioShow",
      "isAudioBarShow",
      "chatLoading",
      "homeChat",
      "isToastShow",
      "OpenChatID",
      "feedbackType",
      "feedbackDirection",
      "isVoiceInput",
      "isToSpeakIng",
      "isEnterFirst",
      "AutoplayPlayer",
      "isPermitUseMicrophone",
      "MicrophoneErrorData",
      "robotConfig",
      "chatData",
      "thinkingData",
      "isVoiceClick",
      "audioList",
      "AutoplayIng",
    ]),
    ...mapState("audio", ["fPlayer", "xPlayer", "audioCurrentIndex"]),
    selectTourList() {
      const { selectList, tourSelectType } = this.$store.state;
      // console.info('tourSelectType',tourSelectType, selectList)
      return tourSelectType
        ? selectList.filter((it) => {
          return it.value == tourSelectType;
        })[0].children
        : [];
    },
    isMb() {
      var ua = window.navigator.userAgent
      if (/Android|webOS|iPhone|iPod|BlackBerry|Windows Phone|Harmony/i.test(ua)) {
        if (window.innerHeight === 1920) {
          return false
        } else {
          return true
        }
      }
      return false
    }
  },
  methods: {
    ...mapMutations([
      "contactDisData",
      "setHomeData",
      "setToastList",
      "setLinkSrc",
      "setGlobalDuration",
      "setChatLoading",
      "setClearTimer",
      "setInputShow",
      "setMaskShowStatus",
      "setTourSelectData",
      "setToastShow",
      "setToastContent",
      "setAudioBarShow",
      "setVoiceInput",
      "setXFAutoplay",
      "setEnterFirst",
      "setAutoplayPlayer",
      "setAutoplayIng",
      "setChatData",
      "setThinkingData",
      "setUserId",
    ]),
    ...mapMutations("audio", [
      "setAudioList",
      "setAudioCurrentIndex",
      "setAudioCurrentTime",
      "setDuration",
      "setXPlayer",
      "setFPlayer",
    ]),
    ...mapActions([
      "fetchRelate",
      "fetchHome",
      "fetchNotice",
      "discussNews",
      "queryPoke",
      "getTourSelectData",
      "queryTourism",
      "queryAudioSearch",
      "getFakeUser",
      "feedbackDataAsync",
      "setMaskDataAsync",
      "deepseekSocket",
      "stopDeepseekSocket",
    ]),

    refreshPage() {
      window.location.reload();
    },

    onStop() {
      // console.log('停止生成', this.stopDeepseekSocket)
      this.stopDeepseekSocket({})
    },

    setUserIdRandom() {
      let a = Math.random() * 1000000

      this.setUserId(parseInt(a))
    },

    onTipClick(item) {
      if (this.chatLoading || this.isToSpeakIng || this.AutoplayIng) {
        return
      }
      let chat = {
        type: 1,
        text: item.question,
        isSample: true,
        answer: item.answer,
      }
      this.setChatData(chat)
      this.deepseekSocket({ payload: { content: chat.text, answer: chat.answer, audio: item.audio, person: "小蜀" } })
    },

    onNpcTipClick() {
      this.$router.push({
        path: '/npc-deputy',
      })
    },

    onStopType() {
      console.log('停止输出')
      // this.setChatLoading(false);
      this.goToBottom();
      clearInterval(this.typedIntervel);
    },

    onStringTyped() {
      console.log('正在输出')
      this.typedIntervel = setInterval(() => {
        this.goToBottom();
        console.log('到底部')
      }, 500)
    },

    onAsk() {
      let that = this;
      this.isToast = false;
      this.service.pageScrollTo();
      this.setToastList([]);
      // let inputValue = this.inputValue.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.inputValue !== "") {
        let chat = {
          type: 1,
          text: this.inputValue
        }
        this.setChatData(chat)
        this.deepseekSocket({ payload: { content: chat.text, person: "小蜀" } })
        // this.onRequest(this.inputValue, this.inputValue, false, "input");
        this.inputBtnInit = true;

        this.inputValue = ''
      } else {
        return;
      }
    },

    resetAsk(text, index, i) {
      let chat = {
        type: 4, // 重新生成
        text: text
      }
      // this.pageInfo[index] =  {}
      // this.setChatData(chat)
      this.deepseekSocket({ payload: { content: chat.text, chatIndex: index, chatListIndex: i, person: "超妹" } })

      setTimeout(() => {
        this.pageInfo[index] = this.pageInfo[index] ? this.pageInfo[index] + 1 : 2
      }, 2000)
    },

    goToBottom() {
      setTimeout(() => {
        // document.getElementById('section').scrollIntoView({
        //   behavior: 'smooth',
        //   block: 'end'
        // });
        var container = document.getElementById("question-section");
        container.scrollTop = container.scrollHeight;
      },)
    },

    onRequest(name, value, hasClearTimer, type) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.setClearTimer(true);
      that.contactDisData([{ content: { right: true, tips: name } }]);
      that.inputValue = "";
      // value = value.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.isOpenChat) {
        switch (this.OpenChatID) {
          case 0:
            {
              that
                .discussNews({
                  payload: { question: value, newsId: this.readNewsId },
                })
                .then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  cio.track(7, "click", "send_msg", { msg: value });

                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 100);
                });
            }
            break;
          case 1:
            {
              that
                .feedbackDataAsync({
                  payload: {
                    content: value,
                    feedbackDirection: that.feedbackDirection,
                    feedbackType: that.feedbackType,
                  },
                })
                .then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  cio.track(7, "click", "send_msg", { msg: value });

                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 100);
                });
            }
            break;
        }
      } else if (this.isAudioShow && type === "button") {
        // that.setAudioList([])
        that.setAudioCurrentIndex(-1);
        setTimeout(() => {
          // this.xPlayer && this.xPlayer.pause()
          that.setAudioCurrentTime(0);
          that.setDuration(0);
          that
            .fetchHome({ payload: { question: value, hasClearTimer } })
            .then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              cio.track(7, "click", "send_msg", { msg: value });
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 100);
            });
        }, 1000);
      } else if (this.isAudioShow && type === "input") {
        // that.setAudioList([])
        that.setAudioBarShow(false);
        that.setAudioCurrentIndex(-1);
        setTimeout(() => {
          that.setAudioCurrentTime(0);
          that.setDuration(0);
          that
            .fetchHome({ payload: { question: value, hasClearTimer } })
            .then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              cio.track(7, "click", "send_msg", { msg: value });
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 100);
            });
        }, 1000);
      } else {
        that
          .fetchHome({ payload: { question: value, hasClearTimer } })
          .then((res) => {
            if (res.length) {
              that.setChatLoading(false);
            }
            cio.track(7, "click", "send_msg", { msg: value });
            setTimeout(() => {
              that.service.pageScrollTo();
            }, 100);
          });
      }
    },

    onRateAsk(value) {
      this.isToast = false;
      this.setToastList([]);
      cio.track(4, "click", "foot_shortcut", { shortcutName: value });
      // cio.track(5,'click', "click_scene",{sceneName:value});
      this.onRequest(value, value, false);
      this.inputBtnInit = true;
    },

    onRate() {
      let that = this;
      // 输入文字，语音切换按钮替换为发送按钮
      if (this.inputValue.length > 0) {
        that.inputBtnInit = false;
      } else {
        that.inputBtnInit = true;
      }
      if (this.inputValue !== "") {
        that.setClearTimer(true);
        that.isToast = true;
        // that
        //   .fetchRelate({ payload: { question: this.inputValue } })
        //   .then((res) => {
        //     that.toastCurrList = parseData(res, this.inputValue);
        //   });
      } else if (this.isAudioShow) {
        that.setClearTimer(true);
        that.toastCurrList = [];
        that.isToast = false;
        that.setToastList([]);
      } else {
        that.setClearTimer(false);
        that.toastCurrList = [];
        that.isToast = false;
        that.setToastList([]);
      }
    },
    onBlur() {
      // console.info("onBlur");
      let that = this;
      setTimeout(() => {
        that.setMaskShowStatus(false);
      }, 0);
    },

    onQuickAsk(name, value) {
      //加载完毕才能点击快速访问按钮

      if (!this.chatLoading && this.homeChat.length) {
        this.onRequest(name, value, true, "button");
      }
    },

    onPoke(name, value) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.setClearTimer(true);
      that.contactDisData([{ content: { right: true, tips: name } }]);

      that.queryPoke().then((res) => {
        if (res.length) {
          that.setChatLoading(false);
        }
        setTimeout(() => {
          that.service.pageScrollTo();
        }, 100);
      });
    },

    onSelectToast(name, value, id, toastType, children, selectType) {
      let that = this;
      this.setToastShow(true);
      this.setToastContent({
        toastType: toastType,
        selectType,
        list: { name: name, content: children },
      });
      this.setTourSelectData(children);
    },

    playAudio(url) {
      this.AutoplayPlayer.setAttribute('src', url)

      setTimeout(() => {
        let player = document.getElementById("AutoplayRef")
        // player.load && player.load();
        // player.pause && player.pause();

        if (player && player.play) {
          // this.setMaskDataAsync({
          //   type: 10,
          //   text: "可以播放语音",
          // });

          player.play()
          this.setAutoplayIng(true);
        } else {
          // this.setMaskDataAsync({
          //   type: 10,
          //   text: "不可以播放语音",
          // });

          // document.getElementById("AutoplayRef").play();
          player.play();
          this.setAutoplayIng(true);

          // document.addEventListener("WeixinJSBridgeReady", function () {  
          //     // audio.play();  
          //     player.play()
          // }, false);  
          // document.addEventListener('YixinJSBridgeReady', function() {  
          //     // audio.play();  
          //     player.play()
          // }, false); 
        }
      }, 0)
    },

    // 初始化音频
    initAudioInput(value) {
      //  权限打开了
      if (this.isPermitUseMicrophone) {
        //  页面以来就打开了
        this.setVoiceInput(value);
        // if (this.isEnterFirst) {
        //进入页面的第一次点击
        //开启自动播放播放器的
        this.setAutoplayPlayer(document.getElementById("AutoplayRef"));
        document.getElementById("AutoplayRef").addEventListener("ended", () => {
          console.log("一次语音播放结束");
          // this.setAutoplayIng(false);
          // this.setChatLoading(false);
          this.goToBottom();

          console.log('this.audioPlayerIndex: ', this.audioPlayerIndex)

          if (this.audioPlayerIndex < this.audioList.length - 1) {
            this.audioPlayerIndex = this.audioPlayerIndex + 1;
            this.playAudio(this.audioList[this.audioPlayerIndex])
          } else {
            console.log('this.audioPlayerIndex: ', this.audioPlayerIndex)
            console.log("所有语音播放结束");
            this.audioPlayerIndex = 0;
            this.setAutoplayIng(false);
            this.setChatLoading(false);
          }
        });
        // this.setXFAutoplay(true);
        // this.setEnterFirst(false);
        // }
      } else {
        if (
          COVERAPP.Attribute.isIOS() &&
          COVERAPP.Attribute.isWeixin() &&
          this.MicrophoneErrorData === "Error"
        ) {
          //  如果是ios 的微信中打开  没有定义getUserMedia 引导下载app
          if (this.device === "ios") {
            popConfirm(
              "请前往下载APP",
              () => {
                window.open("https://apps.apple.com/cn/app/id1028293650");
              },
              () => { }
            );
          } else {
            popConfirm(
              "请前往下载APP",
              () => {
                window.open(
                  "https://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia"
                );
              },
              () => { }
            );
          }
        } else {
          let html = `<div class="NotAllowedError">
            <div class="title">麦克风权限未开启</div>
            `;
          let endhtml = ``;
          if (COVERAPP.Attribute.isApp()) {
            // 是在app中
            if (
              this.MicrophoneErrorData === "Error" &&
              COVERAPP.Attribute.isIOS()
            ) {
              //表示iso系统版本过低
              endhtml = `<div class='des'>你手机系统版本过低，不支持语音录入功能，请更新最新系统</div>
                          </div>`;
            } else if (
              this.MicrophoneErrorData === "Error" &&
              COVERAPP.Attribute.isAndroid()
            ) {
              //表示Android系统版本过低
              endhtml = `<div class='des'>你手机系统版本过低，不支持语音录入功能，请更新最新系统</div>
                          </div>`;
            } else if (
              this.MicrophoneErrorData === "NotAllowedError" ||
              this.MicrophoneErrorData === "PermissionDeniedError"
            ) {
              // app语音权限拒绝
              if (COVERAPP.Attribute.isIOS()) {
                //  ios
                endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【隐私】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                          </div>`;
              } else {
                endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【应用管理】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                                    </div>`;
              }
            }
          } else {
            // 浏览器里面
            if (
              this.MicrophoneErrorData === "NotAllowedError" ||
              this.MicrophoneErrorData === "PermissionDeniedError" ||
              this.MicrophoneErrorData === "NotReadableError" ||
              this.MicrophoneErrorData === "NotFoundError"
            ) {
              // endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【隐私设置和安全性】>【网站】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
              //                     </div>`;
              endhtml = `<div class='des'>检测到麦克风权限未开启，请进入【系统设置】，开启本应用的【麦克风权限】，刷新页面后再进行访问</div>
                                  </div>`;
            } else if (this.MicrophoneErrorData === "Error") {
              endhtml = `<div class='des'>浏览器不能够获取用户麦克风权限</div>
                                  </div>`;
            }
          }

          html = html + endhtml;
          this.setMaskDataAsync({ type: 11, text: html });
        }
      }
    },

    onVoiceInputClick() {
      // console.log('语音按钮点击')
    },

    // 改变用户的输入方式，文字为音频
    onChangeInputType(value) {
      //  权限打开了
      if (this.isPermitUseMicrophone) {
        //  页面以来就打开了
        this.setVoiceInput(value);
        if (this.isEnterFirst) {
          //进入页面的第一次点击
          //开启自动播放播放器的
          this.setAutoplayPlayer(document.getElementById("AutoplayRef"));
          this.AutoplayPlayer.addEventListener("ended", () => {
            // console.log("语音播放结束");
            this.setAutoplayIng(false);
          });
          this.setXFAutoplay(true);
          this.setEnterFirst(false);
        }
      } else {
        if (
          COVERAPP.Attribute.isIOS() &&
          COVERAPP.Attribute.isWeixin() &&
          this.MicrophoneErrorData === "Error"
        ) {
          //  如果是ios 的微信中打开  没有定义getUserMedia 引导下载app
          if (this.device === "ios") {
            popConfirm(
              "请前往下载APP",
              () => {
                window.open("https://apps.apple.com/cn/app/id1028293650");
              },
              () => { }
            );
          } else {
            popConfirm(
              "请前往下载APP",
              () => {
                window.open(
                  "https://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia"
                );
              },
              () => { }
            );
          }
        } else {
          let html = `<div class="NotAllowedError">
            <div class="title">麦克风权限未开启</div>
            `;
          let endhtml = ``;
          if (COVERAPP.Attribute.isApp()) {
            // 是在app中
            if (
              this.MicrophoneErrorData === "Error" &&
              COVERAPP.Attribute.isIOS()
            ) {
              //表示iso系统版本过低
              endhtml = `<div class='des'>你手机系统版本过低，不支持语音录入功能，请更新最新系统</div>
                          </div>`;
            } else if (
              this.MicrophoneErrorData === "Error" &&
              COVERAPP.Attribute.isAndroid()
            ) {
              //表示Android系统版本过低
              endhtml = `<div class='des'>你手机系统版本过低，不支持语音录入功能，请更新最新系统</div>
                          </div>`;
            } else if (
              this.MicrophoneErrorData === "NotAllowedError" ||
              this.MicrophoneErrorData === "PermissionDeniedError"
            ) {
              // app语音权限拒绝
              if (COVERAPP.Attribute.isIOS()) {
                //  ios
                endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【隐私】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                          </div>`;
              } else {
                endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【应用管理】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
                                    </div>`;
              }
            }
          } else {
            // 浏览器里面
            if (
              this.MicrophoneErrorData === "NotAllowedError" ||
              this.MicrophoneErrorData === "PermissionDeniedError" ||
              this.MicrophoneErrorData === "NotReadableError" ||
              this.MicrophoneErrorData === "NotFoundError"
            ) {
              // endhtml = `<div class='des'>麦克风权限未开启，请进入系统【设置】>【隐私设置和安全性】>【网站】>【麦克风】中打开开关，开启麦克风功能之后刷新页面进行访问</div>
              //                     </div>`;
              endhtml = `<div class='des'>检测到麦克风权限未开启，请进入【系统设置】，开启本应用的【麦克风权限】，刷新页面后再进行访问</div>
                                  </div>`;
            } else if (this.MicrophoneErrorData === "Error") {
              endhtml = `<div class='des'>浏览器不能够获取用户麦克风权限</div>
                                  </div>`;
            }
          }

          html = html + endhtml;
          this.setMaskDataAsync({ type: 11, text: html });
        }
      }
    },

    changeFold(index) {
      let key = this.getFoldKey(index)
      this.foldInfo = {
        ...this.foldInfo,
        [key]: !this.foldInfo[key],
      }
      console.log('this.foldInfo: ', this.foldInfo)
    },

    getFoldKey(index) {
      let listIndex = this.pageInfo[index] ? this.pageInfo[index] - 1 : 0
      let key = `${index}-${listIndex}`
      return key
    },

    copyToClip(content, message) {
      let aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      this.setMaskDataAsync({
        type: 10,
        text: message || "已复制至剪切板！",
      });

      setTimeout(() => {
        this.setMaskDataAsync(null);
      }, 1000);
    },

    pageClickAdd(index, length) {
      let n = this.pageInfo[index] || 1
      if (this.pageInfo[index]) {
        if (this.pageInfo[index] > 1) {
          n = n - 1
          this.pageInfo = {
            ...this.pageInfo,
            [index]: n
          }
        } else {
          this.pageInfo = {
            ...this.pageInfo,
            [index]: n
          }
        }
      } else {
        this.pageInfo = {
          ...this.pageInfo,
          [index]: n
        }
      }
    },
    pageClickNext(index, length) {
      let n = this.pageInfo[index] || 2
      if (this.pageInfo[index]) {
        if (this.pageInfo[index] < length) {
          n = n + 1
          this.pageInfo = {
            ...this.pageInfo,
            [index]: n
          }
        } else {
          this.pageInfo = {
            ...this.pageInfo,
            [index]: length
          }
        }
      } else {
        this.pageInfo = {
          ...this.pageInfo,
          [index]: n
        }
      }
    },
    onAudioError() {
      console.log('播报出错')
      this.audioPlayerIndex = 0;
      this.setAutoplayIng(false);
      this.setChatLoading(false);
    }
  },
};
</script>
<style lang="less" scoped>
.PageWrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .fadeInput-enter-active,
  .fadeInput-leave-active {
    transition: opacity 0.5s;
  }

  .fadeInput-enter,
  .fadeInput-leave-to {
    opacity: 0;
  }

  .containerCls {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
  }


  .childView {
    display: flex;
  }

  .contentBox {
    overflow-y: scroll;
  }

  .tourPaddingBottom {
    padding-bottom: 3rem;
  }

  .inputPaddingBottom {
    padding-bottom: 4rem !important;
  }

  .audioPaddingBottom {
    padding-bottom: 3rem;
  }

  .PullToRefresh-inner {
    overflow: hidden;
    /*min-height:100%;*/
  }

  .PullToRefresh {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /*padding-bottom: 2rem;*/
  }

  .iosMinHeight {
    min-height: 8rem;
  }

  .MessageContainer {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex: 1;
    flex: 1;
    min-height: 0;
    /*margin-bottom: 1.3rem;*/
  }

  .questionBox {
    /*height: 3.79rem;*/
    box-sizing: border-box;
    position: absolute;
    bottom: 0.64rem;
    left: 0;
    right: 0;
    z-index: 102;

    .ComposerPC {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: end;
      justify-content: space-between;
      align-items: center;
      // height: .94rem;
      margin: 0 0.24rem;
      padding: 0 .24rem 0 .32rem;
      background: rgba(0, 0, 0, 0.56);
      border-radius: 0.48rem;
      border: 0.02rem solid #FFFFFF;
    }

    .inputCls {
      // width: 80%;
      flex: 1;
      height: .94rem;
      // min-height: .94rem;
      // max-height: 3.46rem;
      margin-right: 0.1rem;
      padding: 0;
      line-height: .94rem;
      font-family: SourceHanSerifCNRegular;
      font-size: 0.28rem;
      color: rgba(255, 255, 255, 1);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-appearance: none;
      background: none;
      border: none;
      outline: none;

      &::placeholder {
        font-family: SourceHanSerifCNRegular;
        font-size: 0.28rem;
        color: rgba(255, 255, 255, .5);
      }
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: center;
      border-radius: 50%;
      font-size: 0.36rem;
      color: #fff;
      font-weight: 600;

      .send {
        display: block;
        width: .48rem;
        height: .48rem;
        // background: url(../assets/img/home/send.png) left top / 100% 100% no-repeat;
      }
    }

    .button-icon {
      display: block;
      width: 0.48rem;
      height: 0.48rem;
    }

    .disable {
      background: #f0f2f5;
    }
  }

  .audioWrapper {
    width: 8.72rem;
    height: 2.48rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
    border-radius: 0.16rem;
    /*position: fixed;*/
    position: absolute;
    bottom: 2.5rem;
    left: calc(50% - 4.36rem);
    z-index: 101;
  }

  .bottomAudioWrapper {
    width: 8.72rem;
    height: 2rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
    border-radius: 0.16rem;
    /*position: fixed;*/
    position: absolute;
    bottom: 0;
    left: calc(50% - 4.36rem);
    z-index: 101;
  }

  .voiceInput-wapper {
    position: absolute;
    bottom: .9rem;
    left: 0;
    width: 100%;
  }

  .tips-info {
    position: absolute;
    bottom: .5rem;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: .21rem;
    color: #FFFFFF;
  }

  .registration-number {
    position: absolute;
    bottom: .2rem;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: .18rem;
    color: #FFFFFF;
  }

  .infoArea {
    position: absolute;
    width: 6.8rem;
    // height: 4.8rem;
    height: 1.8rem;
    background: url("../assets//img/ai-pf//all-border.png") no-repeat;
    background-size: 100% 100%;
    bottom: 1.7rem;
    left: 50%;
    transform: translate(-50%);

    .tipsArea {
      position: absolute;
      padding: 0.25rem 0rem;
      top: 0rem;
      left: 5%;
      width: calc(90% - 0.6rem);
      height: 1.5rem;
      // background: url("../assets/img/ai-pf/tips-border.png") no-repeat;
      background-size: 100% 100%;
      z-index: 100;

      .item-guide {
        font-size: .28rem;
        color: #334a13;
        font-weight: bold;
      }

      .tips-item {
        font-size: .24rem;
        white-space: nowrap;
        margin-top: 0.14rem;
        color: #334a13;
        letter-spacing: -1px;
      }
    }

    .questionArea {
      position: absolute;
      bottom: .7rem;
      padding-top: 0.4rem;
      width: 100%;
      height: 2.2rem;
      // margin: .46rem;
      overflow-y: auto;
      -webkit-mask-image: linear-gradient(to top,
          // transparent,
          black 90%,
          transparent);
      mask-image: linear-gradient(to top,
          // transparent,
          black 90%,
          transparent);


      .call-message-agent-item {
        width: 100%;
        font-weight: 400;
        font-size: .22rem;
        margin-bottom: 0.2rem;

        .is-agent {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          text-align: left;

          ._content {
            position: relative;
            white-space: normal;
            min-width: 1.5rem;
            max-width: 80%;
            padding: 0.1rem 0.15rem 0.3rem 0.15rem;
            background: linear-gradient(to bottom,
                rgba(255, 255, 255, 0.8),
                rgba(247, 240, 220, 0.8));
            color: #333;
            border-radius: 0.2rem;
            border-top: 1px solid #a38e5d;
            border-bottom: 1px solid #a38e5d;
            margin-left: 0.3rem;
            line-height: .4rem;

            .thinking-area {
              display: flex;
              margin-top: 0.2rem;

              .thinking-text {
                font-size: .22rem;
              }

              .thinking-icon {
                width: .24rem;
                height: .24rem;
                margin-right: .08rem;
                background: url(../assets/img/ai-pf/thinking.png) left top / 100% 100% no-repeat;
                // rotateImg
                animation: rotateImg 2s linear infinite;

                &.over {
                  animation: none;
                }
              }
            }


            // &::before {
            //   position: absolute;
            //   left: -0.12rem;
            //   top: 0.175rem;
            //   content: "";
            //   width: 0.12rem;
            //   height: calc(100% - 0.4rem);
            //   border-radius: 20px 0 0 20px;
            //   border: 1px solid #a38e5d;
            //   border-right: none;
            //   background: linear-gradient(to bottom,
            //       rgba(255, 255, 255, 0.8),
            //       rgba(247, 240, 220, 0.8));
            // }

            // &::after {
            //   position: absolute;
            //   right: -0.12rem;
            //   top: 0.175rem;
            //   content: "";
            //   width: 0.12rem;
            //   height: calc(100% - 0.4rem);
            //   border-radius: 0 16px 16px 0;
            //   border: 1px solid #a38e5d;
            //   border-left: none;
            //   background: linear-gradient(to bottom,
            //       rgba(255, 255, 255, 0.8),
            //       rgba(247, 240, 220, 0.8));
            // }

            .tag {
              position: absolute;
              right: 0;
              bottom: 0;
              padding: 0 .13rem 0 .1rem;
              line-height: .3rem;
              font-size: .16rem;
              color: rgba(255, 255, 255, .7);
              background: #f64b49;
              border-radius: 0.14rem 0 0.14rem 0;
            }
          }
        }
      }

      .call-message-user-item {
        width: 100%;
        position: relative;
        font-weight: 400;
        font-size: .22rem;
        margin-bottom: 0.2rem;

        .is-user {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          text-align: left;

          ._content {
            position: relative;
            white-space: normal;
            min-width: 1.5rem;
            max-width: 80%;
            padding: 0.14rem 0.1rem;
            background: rgba(222, 117, 34, 0.85);
            color: #fff;
            border-radius: 10px;
            margin-right: 0.3rem;
            border-top: 1px solid #fff;
            box-shadow: 0 -8px 4px -8px rgba(255, 255, 255, 0.85);

            .thinking-icon {
              width: .29rem;
              height: .29rem;
              margin-right: .08rem;
              background: url(../assets/img/ai-pf/thinking.png) left top / 100% 100% no-repeat;
              // rotateImg
              animation: rotateImg 2s linear infinite;

              &.over {
                animation: none;
              }
            }

            &::before {
              position: absolute;
              left: -0.07rem;
              top: 0.15rem;
              content: "";
              width: 0.07rem;
              height: calc(100% - 0.3rem);
              border-radius: 30px 0 0 30px;
              background: rgba(222, 117, 34, 0.85);
              border-top: 1px solid #fff;
              box-shadow: 0 -8px 4px -8px rgba(255, 255, 255, 0.85);
            }

            &::after {
              position: absolute;
              right: -0.07rem;
              top: 0.15rem;
              content: "";
              width: 0.07rem;
              height: calc(100% - 0.3rem);
              border-radius: 0 30px 30px 0;
              background: rgba(222, 117, 34, 0.85);
              border-top: 1px solid #fff;
              box-shadow: 0 -8px 4px -8px rgba(255, 255, 255, 0.85);
            }
          }
        }
      }

    }

  }

  .phoneArea {
    height: 2.2rem;
  }

  .pcArea {
    height: 2.2rem;
  }

  .verseArea {
    position: absolute;
    top: 1.2rem;
    width: 75%;
    left: 12.5%;
    height: 1.8rem;
    background: url("../assets/img/ai-pf/logo.png") no-repeat;
    background-size: 100% 100%;
  }

  .logoArea {
    position: absolute;
    top: .5rem;
    width: 4.16rem;
    height: .45rem;
    left: 50%;
    transform: translateX(-50%);
    background: url("../assets/img/ai-pf/logo-2.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
